interface LogoProps {
  className?: string;
  width?: number;
  height?: number;
  showText?: boolean;
}

export default function Logo({ className = "", width = 44, height = 44, showText = false }: LogoProps) {
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <img
        src="/images/generated/compressed_WhatsApp-Image-2026-07-18-at-11.45.30-AM.webp"
        alt="NIMAS Dirang logo"
        width={width}
        height={height}
        className="inline-block object-contain rounded-full"
        style={{ width: `${width}px`, height: `${height}px` }}
      />
      {showText && (
        <span className="font-bold text-gray-900 text-base tracking-wide whitespace-nowrap font-heading">
          NIMAS Dirang
        </span>
      )}
    </div>
  );
}